// tslint:disable: max-line-length
import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { emailRegex, SOMENTE_LETRAS, LANDLINE_MASK, VALIDA_CELULAR, CELLPHONE_MASK, SOMENTE_LETRAS_FILTER, VALIDA_CELULAR_FIXO } from '../../../core/constants/consts';
import { SelectOption } from '../dropdown-select/dropdown-select.component';
import { LeadFormService } from 'src/app/core/services/lead-form/lead-form.service';
import { Profile } from 'src/app/core/models/profile';
import { finalize, take } from 'rxjs/operators';
import { Channels } from 'src/app/core/models/channels';
import { PhoneService } from 'src/app/core/services/phone/phone.service';
import { GoogleTagManagerService } from 'src/app/core/analytics/google-tag-manager.service';
import { ContactEventTagBuilder } from '../../contact-event-tag.builder';
export enum ChannelsEnum {
  TELEFONE = '1',
  EMAIL = '2',
  WHATSAPP = '3'
}
@Component({
  selector: 'app-lead-form',
  templateUrl: './lead-form.component.html',
  styleUrls: ['./lead-form.component.scss']
})
export class LeadFormComponent implements OnInit {

  @Input() isWhatsapp: boolean;
  @Input() profile: Profile;
  leadForm: FormGroup;
  errorForm: boolean;
  formSubmited: boolean;
  selectDisplayValue = 'Selecione a forma de contato';
  channels: Array<{id: string, description: string}>;
  oldName = '';
  descriptionSuccess: string;
  phoneMask = LANDLINE_MASK;
  phoneLenght: number;
  loading: boolean;

  constructor(
    public readonly fb: FormBuilder,
    public readonly leadService: LeadFormService,
    private readonly phoneService: PhoneService,
    private readonly googleTagService: GoogleTagManagerService
  ) { }

  ngOnInit() {
    this.channels = new Channels().withoutChat();
    this.buildForm();
  }

  submitLead(e) {
    e.preventDefault();
    this.errorForm = false;
    this.loading = true;
    const companyId = this.profile.company_id;
    const channel = this.leadForm.get('channel').value;
    const phoneBroker = this.phoneService.getCellphoneCheckingCountry(this.profile);
    const lead = this.leadService.buildLead(
      channel, companyId, this.leadForm, this.profile.nickname
    );

    this.sendAnalitycs(channel);

    this.leadService.save(lead)
    .pipe(take(1), finalize(() => this.loading = false))
    .subscribe(() => {
      this.getMsgSuccess(channel);
      this.leadService.startCommunicationForWhatsApp(
        channel, phoneBroker
      );
      this.formSubmited = true;
    },
    err => this.errorForm = true);
  }

  getMsgSuccess(channel) {
    if (channel === ChannelsEnum.WHATSAPP) {
      this.descriptionSuccess = 'Aguarde o carregamento da página para conversar com nossos corretores.';
    } else {
      this.descriptionSuccess = 'Aguarde a confirmação com um consultor.';
    }
  }

  changeSubject(select: SelectOption) {
    this.selectDisplayValue = select.description;
    this.leadService.sendLeadEventForCheckout(select.description);
  }

  buildForm() {
    this.leadForm = this.fb.group({
      name: ['', [
        Validators.required,
        Validators.pattern(SOMENTE_LETRAS),
        Validators.maxLength(100)
      ]],
      email: ['', [
        Validators.required,
        Validators.pattern(emailRegex)
      ]],
      telefone: ['', [
        Validators.required,
        Validators.pattern(VALIDA_CELULAR_FIXO)
      ]],
      channel: [null, Validators.required]
    });
    if (this.isWhatsapp) {
      this.leadForm.get('channel').setValue(ChannelsEnum.WHATSAPP);
      this.selectDisplayValue = 'Whatsapp';
    }
  }

  onNameInputFieldBlur() {
    const name = this.leadForm.get('name').value;
    this.leadService.checkNameChanged(name, this.oldName);
    this.oldName = name;
  }

  filterLetters() {
    const letters = this.leadForm.get('name').value.replace(SOMENTE_LETRAS_FILTER, '');
    this.leadForm.get('name').setValue(letters);
  }

  onPhoneChanged(e: KeyboardEvent): void {
    // tslint:disable: deprecation
    const phoneValue = this.leadForm.get('telefone').value;
    // e.keyCode === 8 = backspace
    if (this.phoneLenght < 10 || e.keyCode === 8) {
      this.phoneMask = LANDLINE_MASK;
    } else if (this.phoneLenght === 10) {
      this.phoneMask = CELLPHONE_MASK;
      this.leadForm.get('telefone').setValue(phoneValue + e.key);
    }
    this.phoneLenght = this.leadForm.get('telefone').value.length;
  }

  private sendAnalitycs(channel: ChannelsEnum): void {

    const tag = new ContactEventTagBuilder()
    .fromAgentPage()
    .toCallbackAction()
    .withLabel(new Channels().channelById(channel)?.toLocaleLowerCase())
    .build();

    this.googleTagService.pushTag(tag);
  }
}
